<template>
  <div class="search">
    <div class="searchInput">
      <i class="el-icon-arrow-left" @click="GoBack"></i>
      <el-input class placeholder="请输入内容" v-model="serachWord" clearable></el-input>
      <div style="width:3rem;margin:0rem 0.5rem" @click="serchInfo(serachWord)">搜索</div>
    </div>
    <div v-if="serachWord.length == 0">
      <div class="searchHistory">
        <div class="title">历史记录</div>
        <div v-if="historyList.length > 0">
          <div v-for="(item,key) in historyList" :key="key" @click="serchInfo(item)">{{item}}</div>
        </div>
        <div v-if="historyList.length == 0" style="font-size:0.8rem">暂无记录</div>
      </div>
      <div v-if="showHotWord" class="searchHot">
        <div
          style="width:50%"
          v-for="(item,key) in hotWordList"
          :key="key"
          @click="serchInfo(item)"
        >{{item}}</div>
        <div @click="hideHotWord(false)" style="color:#777">隐藏推荐词</div>
      </div>
      <div v-if="!showHotWord" style="text-align:center;color:#777">
        <span @click="hideHotWord(true)">
          <i class="el-icon-view"></i>
          查看全部推荐词
        </span>
      </div>
    </div>
    <div v-if="serachWord.length > 0" style="padding:0rem 0.5rem">
      <div v-for="(item,key) in resultList" :key="key">
        <div v-if="item.resourceItem =='LIVE'&& item.resources.length >0">
          <div style="color:#01999d;margin-bottom:0.3rem">直播</div>
          <div
            v-for="(childItem,childKey) in item.resources"
            :key="childKey"
            style="margin-bottom:0.5rem"
            @click="gotToDetail(childItem.id,item.resourceItem)"
          >
            <img :src="getImageURL(childItem.cover)" style="width:100%" />
            <div style="background:#44444480;color:#FFF;padding:0.3rem 0rem">{{childItem.title}}</div>
          </div>
        </div>
        <div v-if="item.resourceItem =='VIDEO'&& item.resources.length >0">
          <div style="color:#01999d;margin-bottom:0.3rem">视频</div>
          <div
            v-for="(childItem,childKey) in item.resources"
            :key="childKey"
            style="margin-bottom:0.5rem"
            @click="gotToDetail(childItem.id,item.resourceItem)"
          >
            <img :src="getImageURL(childItem.cover)" style="width:100%" />
            <div
              style="margin-top: -2rem;height: 2rem;color: #FFF;padding-left: 0.5rem;font-size: 0.9rem;"
            >{{childItem.title}}</div>
          </div>
        </div>
        <div v-if="item.resourceItem =='NEWS'&& item.resources.length >0">
          <div style="color:#01999d;margin-bottom:0.3rem">资讯</div>
          <div
            v-for="(childItem,childKey) in item.resources"
            :key="childKey"
            style="margin-bottom:0.5rem"
            @click="gotToDetail(childItem.id,item.resourceItem)"
          >
            <div>{{childItem.title}}</div>
            <img :src="getImageURL(childItem.cover)" style="width:100%" />
            <div>
              <span>{{childItem.authorName}}</span>
              <span>{{childItem.commentNumber}}评论</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as request from "@/utils/request";
import { getImageURL } from "@/utils/zgly-utils.js";
export default {
  data() {
    return {
      VUE_APP_BASE_API: process.env.VUE_APP_BASE_API,
      serachWord: "",
      historyList: [],
      hotWordList: [],
      resultList: [],
      showHotWord: true
    };
  },
  created(){
    let content =  this.$route.query.content
    if(content){
      this.serachWord = content;
      this.serchInfo(content)
    }
  },
  mounted() {
    this.getSearchHot();
    this.getHistories();
  },
  methods: {
    getImageURL(cover) {
      return getImageURL(cover);
    },
    getHistories() {
      request.getHistories().then(({ data }) => {
        data && (this.historyList = data);
      });
    },
    getSearchHot() {
      request.getSearchHotWord({ size: 15 }).then(({ data }) => {
        this.hotWordList = data;
      });
    },
    serchInfo(val) {
      this.serachWord = val;
      this.resultList = [];
      request.getSearch({ title: val }).then(({ data }) => {
        this.resultList = data;
      });
    },
    searchReasult() {
      console.log();
    },
    GoBack() {
      this.$router.push({ path: `/` });
    },
    hideHotWord(val) {
      this.showHotWord = val;
    },
    gotToDetail(id, type) {
      if(type == "LIVE" ){
      this.$router.push({ path: `/live/player/${id}?type=${type}` });
      }else if( type == "VIDEO"){
      this.$router.push({ path: `/video/player/${id}?type=${type}` });
      }else if(type == "NEWS"){
      this.$router.push({ path: `/news/details/${id}?type=${type}` });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.search {
  .searchInput {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.5rem;
    i {
      font-size: 1.5rem;
      font-weight: bolder;
    }
  }
  .searchHistory {
    margin: 0.5rem;
    padding: 0.5rem 0rem;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    .title {
      margin-bottom: 0.5rem;
      color: #666;
    }
  }
  .searchHot {
    display: flex;
    flex-wrap: wrap;
    margin: 0.5rem;
    div {
      width: 49%;
      margin-right: 1%;
      margin: 0.5rem 0rem;
    }
  }
}
</style>